import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { BackgroundService } from 'backgroundservice';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(private geolocation: Geolocation) {}

  async getCurrentLocation(): Promise<{ latitude: number; longitude: number }> {
    try {
      await BackgroundService.checkLocationPermission();
      const resp = await this.geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: 20000
      });
      return {
        latitude: resp.coords.latitude,
        longitude: resp.coords.longitude
      };
    } catch (error) {
      console.error('Error getting location', error);
      throw error;
    }
  }

  watchPosition(callback: (pos: { latitude: number; longitude: number }) => void): any {
    const watch = this.geolocation.watchPosition({
      enableHighAccuracy: true
    });
    const subscription = watch.subscribe((data: any) => {
      if (data && data.coords) {
        callback({
          latitude: data.coords.latitude,
          longitude: data.coords.longitude
        });
      }
    });
    return subscription;
  }

  stopWatching(subscription: any): void {
    if (subscription && subscription.unsubscribe) {
      subscription.unsubscribe();
    }
  }
}
